import "./index.css";
import { useTheme, ThemeProvider } from './config/ThemeContext';
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import MatchSetup from "./components/MatchSetup";
import LiveScoring from "./components/LiveScoring";
import SeasonManagement from "./components/SeasonManagement";
import TeamManagement from "./components/TeamManagement";
import PlayerManagement from "./components/PlayerManagement";
import PreMatchSetup from "./components/PreMatchSetup";
import PreSetSetup from "./components/PreSetSetup";
import Home from "./components/Home";
import Login from "./components/Login";
import Signup from "./components/Signup"; // Add this import
import RecomputeMatch from "./components/RecomputeMatch";
import Schedule from "./components/Schedule";
import TeamRanking from "./components/TeamRanking";
import PlayersRanking from "./components/PlayersRanking";
import MatchReport from "./components/MatchReport";
import MatchPlayersRankingReport from "./components/MatchPlayersRankingReport";
import TeamReport from "./components/TeamReport";
import RequestPasswordReset from "./components/RequestPasswordReset";
import ResetPassword from "./components/ResetPassword";
import apiClient from "./services/apiClient";

function Header({ onLogout }) {
  return (
    <header className="bg-white shadow-sm py-3 px-6 flex justify-between items-center">
      {/* Left side: Home link */}
      <Link
        to="/"
        className="flex items-center text-sm text-gray-500 hover:text-gray-700 transition-colors"
      >
        
	<img
	  src="/assets/logos/volleyfly-icon-50x50.png"
	  height="40"
	  width="40"
	  alt="VolleyFly Home"
	  title="VolleyFly Home"
	  className="mx-auto pr-2"
	/> 
        
      </Link>

      {/* Right side: Logout button */}
      <button
        onClick={onLogout}
        className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 transition-colors"
      >
        <span className="material-icons text-base">logout</span>Log Out
      </button>
    </header>
  );
}

function App() {
  const [auth, setAuth] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const bootstrapAuth = async () => {
      try {
        const response = await apiClient.post("/api/auth/refresh-token");
        setAuth({ role: response.data?.role || "scout" });
      } catch (error) {
        setAuth(null);
      } finally {
        setLoading(false);
      }
    };
    bootstrapAuth();
  }, []);

  const handleLogin = (user) => {
    setAuth(user);
  };

  const handleLogout = () => {
    apiClient.post("/api/auth/logout").finally(() => setAuth(null));
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <ThemeProvider>
      <Router>
        <div>
          {auth ? (
            <>
              <Header onLogout={handleLogout} />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/live-scoring/:matchId" element={<LiveScoring />} />
                <Route path="/season-management" element={<SeasonManagement />} />
                <Route path="/team-management/:seasonId" element={<TeamManagement />} />
                <Route path="/player-management/:teamId" element={<PlayerManagement />} />
                <Route path="/matches/setup/:seasonId?" element={<MatchSetup />} />
                <Route path="/matches/pre-match/:matchId" element={<PreMatchSetup />} />
                <Route path="/matches/pre-set/:matchId/:setNumber" element={<PreSetSetup />} />
                <Route path="/live-scoring/:matchId/:setId" element={<LiveScoring />} />
                <Route path="/recompute" element={<RecomputeMatch />} />
                <Route path="/schedule/:seasonId" element={<Schedule />} />
                <Route path="/seasons/:seasonId/team-ranking" element={<TeamRanking />} />
                <Route path="/seasons/:seasonId/players-ranking" element={<PlayersRanking />} />
                <Route path="/matches/:matchId/report" element={<MatchReport />} />
                <Route path="/matches/:matchId/players-ranking" element={<MatchPlayersRankingReport />} />
                <Route path="/teams/:teamId/report" element={<TeamReport />} />
              </Routes>
            </>
          ) : (
            <Routes>
              <Route path="/signup" element={<Signup />} />
				<Route path="/request-password-reset" element={<RequestPasswordReset />} />
				<Route path="/reset-password" element={<ResetPassword />} />
              <Route path="*" element={<Login onLogin={handleLogin} />} />
            </Routes>
          )}
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
